import { Space } from '@procurify/ui'

import { FeaturePromotionModal } from '@webapp/core/components/FeaturePromotionModal'
import { RequestFeatureDemoButtonPresenter } from '@webapp/core/features/request-feature-demo/presenters/RequestFeatureDemoButtonPresenter'
import { TakeProductTourButtonPresenter } from '@webapp/core/features/take-product-tour/presenters/TakeProductTourButtonPresenter'
import {
  DiscoverMorePageTabs,
  useDiscoverMoreFeatureContent,
} from '@webapp/platform/discover-more'

export interface IGuidedIntakePromoModalProps {
  open: boolean
  onClose: () => void
}

export const GuidedIntakePromoModal = ({
  open,
  onClose,
}: IGuidedIntakePromoModalProps) => {
  const content = useDiscoverMoreFeatureContent(
    DiscoverMorePageTabs.GUIDED_INTAKE
  )

  if (!content) return null

  const {
    header,
    description,
    proofPoints = [],
    heroVideo,
    heroImage,
    heroImageAlt,
    tourTitle,
    demoRequestContext,
    demoRequestDisclaimer,
    demoRequestButtonText,
  } = content

  return (
    <FeaturePromotionModal
      open={open}
      onClose={onClose}
      header={header}
      descriptionText={description}
      imageSrc={heroVideo?.poster ?? heroImage ?? ''}
      imageAlt={heroImageAlt}
      bullets={proofPoints.map((proofPoint) => proofPoint.text)}
      disclaimerText={demoRequestDisclaimer}
      cta={
        <Space direction='horizontal' size='small' align='center'>
          <RequestFeatureDemoButtonPresenter
            context={demoRequestContext}
            buttonText={demoRequestButtonText}
            variant='secondary'
          />
          <TakeProductTourButtonPresenter
            context={demoRequestContext}
            title={tourTitle}
            variant='primary'
            onTourOpened={onClose}
          />
        </Space>
      }
    />
  )
}

GuidedIntakePromoModal.displayName = 'GuidedIntakePromoModal'
